/**
 * Created by user on 2020/6/11.
 */
import { colorizeDiff } from './lib/colorize';

export * from './lib/types';
export * from './lib/colorize';
export * from './lib/core';

export default colorizeDiff
